import $ from 'jquery';

class GroupManagement {
	constructor(){
		// Check if it's the group management page
		if (this.isGroupManagement()) {
			// Create enrolled users table
			new EnrolledUsersTable();

			// Setup modal popups
			window.ulgmGroupManagement.groupManagementModal = new modals();
		}
	}

	isGroupManagement(){
		return $( '#group-management' ).length == 1;
	}
}

class modals {
	constructor(){
		$( document ).on( 'modal:open', function ( e ){
			if (e.target.id === 'group-management-email-users') {
				wp.editor.remove( 'group_email_text' );
				wp.editor.initialize( 'group_email_text',
					{
						tinymce: {
							min_height: 300,
							formats: {
								alignleft: [{
									selector: "p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li",
									styles: {textAlign: "left"}
								}, {selector: "img,table,dl.wp-caption", classes: "alignleft"}],
								aligncenter: [{
									selector: "p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li",
									styles: {textAlign: "center"}
								}, {selector: "img,table,dl.wp-caption", classes: "aligncenter"}],
								alignright: [{
									selector: "p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li",
									styles: {textAlign: "right"}
								}, {selector: "img,table,dl.wp-caption", classes: "alignright"}],
								strikethrough: {inline: "del"}
							},
							toolbar1: 'formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image | forecolor backcolor emoticons',
							plugins: "charmap colorpicker hr lists media paste tabfocus textcolor fullscreen wordpress wpautoresize wpeditimage wpemoji wpgallery wplink wpdialogs wptextpattern wpview"
						},
						quicktags: {
							buttons: 'strong,em,link,ul,ol,li,code'
						}
					} );
			}
		} );

		// Add events for the group management page
		this.addGroupManagementEvents();
	}

	addGroupManagementEvents(){

		// Clear file so we get a fresh copy every time
		$( "#csv-file" ).on( 'click', function (){
			$( this ).val( '' );
		} );

		// There may be other plugin/themes that are using this modal or using the same trigger. let customize the trigger
		$( 'body' ).on( 'click', '.ulgm-modal-link', this.openModal );

		// User csv file input change
		$( '#csv-file' ).on( 'change', this.parseCsv );

		//Hide inupts dependent on radio
		$( "input:radio[name=action]" ).click( function (){
			var value          = $( this ).val();
			var modalContainer = $( this ).parent();

			modalContainer.children( '#first-name, #last-name, #email, label[for=first-name], label[for=last-name], label[for=email-name]' ).show();
            $('#uo_add_user_password').show();

			if ('send-enrollment' === value || 'add-existing-user' === value) {
				modalContainer.children( '#first-name, #last-name, label[for=first-name], label[for=last-name]' ).hide();
				$('#uo_add_user_password').hide();
			}

		} );

		window.ulgmGroupManagement.downloadCsv = function ( csv ){
			var blob = new Blob( [csv.csvDataString], {type: "text/plain;charset=utf-8"} );
			saveAs( blob, csv.fileName + ".csv" );
		};
	}

	openModal( e ){
		e.preventDefault();

		// clear any error messages
		$( '.group-management-form' ).find( '.group-management-rest-message' ).html( '' ).hide();

		var modalId   = $( this ).data( 'modal-id' );
		var modalAjax = $( this ).data( 'modal-ajax' );

		if (modalAjax == true) {
			var endpoint = $( this ).data( 'endpoint' );
			var user     = $( this ).data( 'user-id' );
			var group    = $( this ).data( 'group-id' );
			var restData = {'action': 'get-user-details', 'user': user, 'group-id': group};
			var spinner  = $( '.uo-modal-spinner' );

			$.ajax( {

				method: "POST",
				url: ulgmRestApiSetup.root + endpoint + '/',
				data: restData,

				// Attach Nonce the the header of the request
				beforeSend: function ( xhr ){
					xhr.setRequestHeader( 'X-WP-Nonce', ulgmRestApiSetup.nonce );
				},

				statusCode: {
					403: function ( xhr ){
						spinner.hide();
						$error_container.html( ulgmRestApiSetup.i18n.youCantDoThat ).show();
					}
				},

				success: function ( response ){

					for (var x in response.data) {
						if ($( '#' + x ).length > 0) {
							$( '#' + x ).val( response.data[x].value );
							if (response.data[x].is_editable == false) {
								$( '#' + x ).attr( 'disabled', 'disabled' );
							}
						}
					}
					spinner.hide();

					if (true === response.success) {
						var modal = $( modalId );
						modal.modal();

						$( '#group-management' ).trigger( 'modal-open', [modalId, modal] );
					} else {
						spinner.hide();

						$error_container
							.html( response.data.message )
							.show();
					}
				},

				fail: function ( response ){
					spinner.hide();
					$error_container.html( response.data.message );
				},

			} );

		} else {
			var modal = $( modalId );
			modal.modal();

			$( '#group-management' ).trigger( 'modal-open', [modalId, modal] );
		}
	}

	parseCsv( e ){

		var input            = $( this );
		var messageContainer = $( input.closest( '.group-management-form' ) ).find( '.group-management-rest-message' )

		// Reset Message
		messageContainer.hide();
		messageContainer.text( '' );

		try {
			var reader = new FileReader();
			//do something
		} catch (e) {
			messageContainer.text( ulgmGroupManagementLocalized.text.file_api_is_not_supported ).css( 'display', 'inline-flex' );
			return false;
		}

		var file    = $( '#csv-file' )[0].files[0];
		var csvText = false;


		if (file) {
			// check is csv extension
			if ('csv' !== file.name.split( '.' ).pop()) {
				messageContainer.text( ulgmGroupManagementLocalized.text.select_a_csv ).css( 'display', 'inline-flex' );
				return false;
			}

			reader.readAsText( file );

			reader.onload = function ( e ){

				csvText = e.target.result;

				if (!csvText) {
					messageContainer.text( ulgmGroupManagementLocalized.text.csv_file_error ).css( 'display', 'inline-flex' );
					return false;
				}

				// split file text on line breaks
				var csvArray = csvText.split( /\r?\n/g );

				// Preliminary checks

				// Pull out the header and store it

				var csvHead = csvArray.shift();

				let delimiter = ",";
				if (csvHead.indexOf( ";" ) !== -1) {
					delimiter = ";";
				}


				csvHead = csvHead.split( delimiter );

				// Something is off ... create to detect CR only line breaks where CRLF is only supported but may detect other malformations
				if (csvHead.length !== 3 && csvArray.length === 0) {
					messageContainer.text( ulgmGroupManagementLocalized.text.incompatible_format ).css( 'display', 'inline-flex' );
					return false;
				}

				// Remove last line of csv that is always blank
				csvArray.pop();

				// Require emails
				var emailIndex = window.ulgmGroupManagement.groupManagementModal.verifyRequiredHeader( csvHead, 'user_email' );
				if ('error' === emailIndex) {
					messageContainer.text( ulgmGroupManagementLocalized.text.not_contains_email ).css( 'display', 'inline-flex' );
					return false;
				}

				// Require user first name
				var firstNameIndex = window.ulgmGroupManagement.groupManagementModal.verifyRequiredHeader( csvHead, 'first_name' );
				if ('error' === firstNameIndex) {
					messageContainer.text( ulgmGroupManagementLocalized.text.not_contains_first ).css( 'display', 'inline-flex' );
					return false;
				}

				// Require user first name
				var lastNameIndex = window.ulgmGroupManagement.groupManagementModal.verifyRequiredHeader( csvHead, 'last_name' );
				if ('error' === lastNameIndex) {
					messageContainer.text( ulgmGroupManagementLocalized.text.not_contains_last ).css( 'display', 'inline-flex' );
					return false;
				}

				var newArray = csvArray.map( function mapper( v ){
					if (typeof v == "string") {
						return v.split( delimiter );
					} else {
						return v.map( mapper );
					}
				} );


				// Check for blank lines
				var emptyRows = window.ulgmGroupManagement.groupManagementModal.verifyEmptyRows( newArray, emailIndex );

				if (emptyRows) {
					messageContainer.text( ulgmGroupManagementLocalized.text.must_contain_email ).css( 'display', 'inline-flex' );
					return false;
				}

				$( '#csv-text' ).val( csvText );


			};
		} else {
			$( input.closest( '.group-management-form' ) ).find( '.group-management-rest-message' ).text( ulgmGroupManagementLocalized.text.choose_file );
			return false;
		}

	}

	verifyEmptyRows( array, emailIndex ){

		for (var i = 0; i < array.length; ++i) {
			if (array[i][emailIndex] === '') {
				return true;
			}
		}

		return false;

	}

	verifyRequiredHeader( headerArray, type ){

		var columnsAmount = 0;
		var columnIndex   = false;
		for (var i = 0; i < headerArray.length; i++) {
			if (headerArray[i] === type) {
				columnsAmount++;
				columnIndex = i;
			}
		}

		if (0 === columnsAmount) {
			return 'error';

		}

		if (1 !== columnsAmount) {
			return 'error';
		}

		return columnIndex;

	}
}

class EnrolledUsersTable {
	constructor(){
		// Check if it has the enrolled users table
		if (this.hasEnrolledUsersTable()) {
			// Get elements
			this.getElements();

			// Get data
			this.getData();

			// Add select2
			this.addSelect2();

			// Create DataTable
			this.createDataTables();

			// Listen the checkbox to select all the users
			this.listenCheckboxToSelectAll();

			// Listen checkboxes changes
			this.listenCheckboxesChanges();

			// Listen modal open and update data
			this.updateDataOnModal();
		}
	}

	getElements(){
		// Get elements
		this.$elements = {
			container: $( '#group-management' ),
			selectEl: $( '.uo-groups select' ),
			enrolledUsersTableDT: $( '#group-management-enrolled-users-datatable' ),
			enrolledLeaderTableDT: $( '#group-management-enrolled-leader-datatable' ),
			removeUsersButton: $( '#group-management-enrolled-users-table-remove-users' ),
			removeLeadersButton: $( '.group-leader-management-buttons' ),
			sendEmailsButton: $( '#group-management-enrolled-users-table-send-password' ),
			numberOfUsers: $( '#group-management .uo-groups-enrolled-users .amount-users' ),
			sendEmailsModal: $( '#group-management-enrolled-users-table-send-password-modal' ),
			sendEmailsField: $( '#group-management-enrolled-users-table-send-password-field' ),
			removeUsersField: $( '#group-management-remove-user #removing-users' )
		}
	}

	addSelect2(){
		// Select group to manage
		if (jQuery.fn.select2) {
			this.$elements.selectEl.select2();
		}

		if ($( '#group-id' ).length > 0) {
			$( '#group-id' ).change( function (){
				$( this ).closest( 'form' ).submit();
			} );
		}
	}

	getData(){
		// Get data from DOM elements
		this.data = {
			canRemoveUsers: !!parseInt( this.$elements.enrolledUsersTableDT.data( 'can-remove-users' ) ),
			canRemoveUsersAnytime: !!parseInt( this.$elements.enrolledUsersTableDT.data( 'can-remove-users-anytime' ) ),
			ulgmGroupLeaderData: null !== ulgmGroupLeaderData ? ulgmGroupLeaderData : [],
		};

		// Set the default array for the selected users on page load
		this.selectedUsers   = [];
		this.selectedLeaders = [];
	}

	createDataTables(){

		/* Create an array with the values of all the input boxes in a column */
		jQuery.fn.dataTable.ext.type.order['uo-groups-anchor-asc'] = function ( a, b ){
			// Create the HTML element
			let textA       = document.createElement( 'div' );
			// Insert the row content inside
			textA.innerHTML = a;
			// Get only the text, not the HTML
			textA           = textA.textContent;
			// Make it lowercase, and remove extra spaces
			textA           = textA.toLowerCase().trim();

			// Now do the same with B
			let textB       = document.createElement( 'div' );
			textB.innerHTML = b;
			textB           = textB.textContent;
			textB           = textB.toLowerCase().trim();

			// Compare text A with text B
			return textA.localeCompare( textB );
		};

		jQuery.fn.dataTable.ext.type.order['uo-groups-anchor-desc'] = function ( a, b ){
			// Create the HTML element
			let textA       = document.createElement( 'div' );
			// Insert the row content inside
			textA.innerHTML = a;
			// Get only the text, not the HTML
			textA           = textA.textContent;
			// Make it lowercase, and remove extra spaces
			textA           = textA.toLowerCase().trim();

			// Now do the same with B
			let textB       = document.createElement( 'div' );
			textB.innerHTML = b;
			textB           = textB.textContent;
			textB           = textB.toLowerCase().trim();

			// Compare text A with text B
			return textB.localeCompare( textA );
		};

		// version 4.0- columns are defined in group-management-interface.php
		let userColumns = this.data.ulgmGroupLeaderData.enrolled_user_columns;

		if ('true' === this.data.ulgmGroupLeaderData.populate_management_features) {
			userColumns.unshift( {
				data: 'check',
				targets: 0,
				title: this.data.ulgmGroupLeaderData.check_all,
				searchable: false,
				orderable: false,
			} );

		}

		//Dropping Key column if its hidden
		if (true !== this.$elements.enrolledUsersTableDT.data( 'key_column' )) {
			let index = userColumns.indexOf( 'key' );
			userColumns.splice( index, 1 );
		}

		let userTableVars = {

			data: this.data.ulgmGroupLeaderData.enrolled_user_data,
			searchDelay: 400,
			columns: userColumns,
			dom: '<"uo-groups-datatable-header"B>frt<"uo-groups-datatable-footer"lpi>',
			order: [[1, 'asc']],
			pageLength: parseInt( this.$elements.enrolledUsersTableDT.data( 'page_length' ) ),
			lengthMenu: [
				[10, 25, 50, 100],
				[10, 25, 50, 100]
			],
			buttons: [
				{
					extend: 'csv',
					text: ulgmRestApiSetup.language.buttons.csvExport,
					filename: function (){
						let groupNamePrefix = 'group-management';
						let groupId        = $( "#ulgm_current_managed_group_id" ).val();
						let groupName       = $( "#group-id option:selected" ).text();
						if (typeof groupName === 'undefined' || '' === groupName) {
							groupName = $( "#group-name" ).text();
						}

						return groupNamePrefix + '-' + groupId + '-' +  groupName;
					}
				}
			],
			language: {
				processing: ulgmRestApiSetup.language.processing,
				search: '_INPUT_',
				searchPlaceholder: ulgmRestApiSetup.language.searchPlaceholder,
				lengthMenu: ulgmRestApiSetup.language.lengthMenu,
				info: ulgmRestApiSetup.language.info,
				infoEmpty: ulgmRestApiSetup.language.infoEmpty,
				infoFiltered: ulgmRestApiSetup.language.infoFiltered,
				infoPostFix: '',
				loadingRecords: ulgmRestApiSetup.language.loadingRecords,
				zeroRecords: ulgmRestApiSetup.language.zeroRecords,
				emptyTable: ulgmRestApiSetup.language.emptyTable,
				paginate: {
					first: ulgmRestApiSetup.language.paginate.first,
					previous: ulgmRestApiSetup.language.paginate.previous,
					next: ulgmRestApiSetup.language.paginate.next,
					last: ulgmRestApiSetup.language.paginate.last
				},
				aria: {
					sortAscending: ulgmRestApiSetup.language.sortAscending,
					sortDescending: ulgmRestApiSetup.language.sortDescending
				}
			},
			processing: false,
			serverSide: false,

			createdRow: function( row, data, dataIndex ){
				$( row )
					.addClass( `status_id-${ data.status_id }` )
			},

			initComplete: () => {
				// Get the export CSV button
				const $fakeExportCSV = document.getElementById( 'group-management-users-export-csv' );

				// Check if the element exists
				if ( document.body.contains( $fakeExportCSV ) ){
					// Add an event listener to listen clicks
					$fakeExportCSV.addEventListener( 'click', () => {
						// Click the real "Export CSV" button
						const $realExportCSV = document.querySelector( '#group-management-enrolled-users-datatable_wrapper .buttons-csv' );

						// Check if the element exists
						if ( document.body.contains( $realExportCSV ) ){
							// Click it
							const event = document.createEvent( 'HTMLEvents' );
							event.initEvent( 'click', true, false );
							$realExportCSV.dispatchEvent( event );
						}
					});
				}
			}
		};

		let userTable = null;

		// User table
		userTable = this.$elements.enrolledUsersTableDT.DataTable( userTableVars );

		$( document ).trigger( 'enrolledUsersTableDataTableCreated', {
			userTableVars: userTableVars,
			userTable: userTable,
			ulgmGroupLeaderData: ulgmGroupLeaderData
		} );

		let leaderColumns = this.data.ulgmGroupLeaderData.enrolled_leader_columns;
		if ('true' === this.data.ulgmGroupLeaderData.populate_management_features) {
			leaderColumns.unshift( {data: 'check', targets: 0, title: this.data.ulgmGroupLeaderData.check_all} );
		}

		let leaderTableVars = {
			data: this.data.ulgmGroupLeaderData.enrolled_leader_data,
			columns: leaderColumns,
			columnDefs: [{
				targets: 0,
				searchable: false,
				orderable: false,
			}],
			dom: 'frt<"uo-groups-datatable-footer"lpi>',
			order: [[1, 'asc']],
			language: {
				processing: ulgmRestApiSetup.language.processing,
				search: '_INPUT_',
				searchPlaceholder: ulgmRestApiSetup.language.searchPlaceholder,
				lengthMenu: ulgmRestApiSetup.language.lengthMenu,
				info: ulgmRestApiSetup.language.info,
				infoEmpty: ulgmRestApiSetup.language.infoEmpty,
				infoFiltered: ulgmRestApiSetup.language.infoFiltered,
				infoPostFix: '',
				loadingRecords: ulgmRestApiSetup.language.loadingRecords,
				zeroRecords: ulgmRestApiSetup.language.zeroRecords,
				emptyTable: ulgmRestApiSetup.language.emptyTable,
				paginate: {
					first: ulgmRestApiSetup.language.paginate.first,
					previous: ulgmRestApiSetup.language.paginate.previous,
					next: ulgmRestApiSetup.language.paginate.next,
					last: ulgmRestApiSetup.language.paginate.last
				},
				aria: {
					sortAscending: ulgmRestApiSetup.language.sortAscending,
					sortDescending: ulgmRestApiSetup.language.sortDescending
				}
			}
		};

		let leaderTable;

		// Try to set the custom page length and length menu attributes
		// This will work only if the user didn't override the uo-groups template
		// before Groups 3.7.3
		try {
			// Set custom page length
			leaderTableVars.pageLength = parseInt( this.$elements.enrolledLeaderTableDT.data( 'page_length' ) );

			// Set custom page length
			leaderTableVars.lengthMenu = this.$elements.enrolledLeaderTableDT.data( 'length_menu' );

			// Leader table
			leaderTable = this.$elements.enrolledLeaderTableDT.DataTable( leaderTableVars );
		} catch (e) {
			console.log( 'Beta: Could not set custom page length and custom menu length' );
			console.log( e );

			// Leader table
			leaderTable = this.$elements.enrolledLeaderTableDT.DataTable( leaderTableVars );
		}

		$( document ).trigger( 'enrolledLeaderTableDataTableCreated', {
			leaderTableVars: leaderTableVars,
			leaderTable: leaderTable,
			ulgmGroupLeaderData: ulgmGroupLeaderData
		} );
	}

	listenCheckboxToSelectAll(){
		// Listen changes to this checkbox
		this.$elements.container.on( 'change', '.group-management-enrolled-select-all', ( event ) => {

			// Get checkbox status
			const checkAllEl = $( event.currentTarget );
			const isChecked  = checkAllEl.is( ':checked' );

			// Get all checkboxes
			const $allCheckboxes = checkAllEl.closest( 'table' ).find( '.select-user' );

			// Check if it's checked
			if (isChecked) {
				// Select all users
				$allCheckboxes.prop( 'checked', true );
			} else {
				// Unselect all users
				$allCheckboxes.prop( 'checked', false );
			}

			// Get the current selected users
			this.updateSelectedUsers();

			// Evalute the visibility of the "Remove users" button
			this.evaluateRemoveUsersButtonVisiblity();

			// Evalute the visibility of the "Remove leaders" button
			this.evaluateRemoveLeadersButtonVisiblity();

			// Evaluate the visibility of the "Send emails" button
			this.evaluateSendEmailsButtonVisiblity();
		} );
	}

	listenCheckboxesChanges(){
		// Add event listener to the checkboxes
		this.$elements.container.on( 'change', 'input[type="checkbox"].select-user', ( event ) => {
			// Get the current selected users
			this.updateSelectedUsers();

			// Evalute the visibility of the "Remove users" button
			this.evaluateRemoveUsersButtonVisiblity();

			// Evalute the visibility of the "Remove leaders" button
			this.evaluateRemoveLeadersButtonVisiblity();

			// Evaluate the visibility of the "Send emails" button
			this.evaluateSendEmailsButtonVisiblity();
		} );
	}

	updateSelectedUsers(){
		// Create array to save selected users
		let selectedUsers   = [];
		let selectedLeaders = [];

		// Get all the checkboxes
		const $allUserCheckboxes   = this.$elements.enrolledUsersTableDT.find( 'input[type="checkbox"].select-user' );
		const $allLeaderCheckboxes = this.$elements.enrolledLeaderTableDT.find( 'input[type="checkbox"].select-user' );

		// Filter all checked and unchecked checkboxes
		const allCheckedCheckboxes = {
			users: $allUserCheckboxes.filter( ':checked' ),
			leaders: $allLeaderCheckboxes.filter( ':checked' ),
		};

		// Get the selected checkboxes
		$.each( allCheckedCheckboxes, ( type, $checkedCheckboxes ) => {
			$.each( $checkedCheckboxes, ( index, checkbox ) => {
				// Get the checkbox
				let $checkbox = $( checkbox );

				let $row = $checkbox.closest( 'tr' );

				if ('users' === type) {
					let status = $row.find( '.status' ).data( 'status' );

					let progressIsNotStarted;
					if ('not-started' === status) {
						progressIsNotStarted = 1;
					} else if ('not-enrolled' === status) {
						progressIsNotStarted = 1;
					} else {
						progressIsNotStarted = 0;
					}

					// Add data to the selectedUsers array
					selectedUsers.push( {
						userId: $checkbox.val(),
						progressIsNotStarted: progressIsNotStarted,
					} );
				}
				if ('leaders' === type) {
					// Add data to the selectedUsers array
					selectedLeaders.push( {
						userId: $checkbox.val()
					} );
				}
			} );
		} );

		// Update selected property
		this.selectedUsers   = selectedUsers;
		this.selectedLeaders = selectedLeaders;
	}

	evaluateRemoveUsersButtonVisiblity(){
		// Create the variable we're going to use to finally
		// decide if we have to show or not the button
		let showRemoveUsersButton = false;

		// Check if there are selected rows
		if (this.selectedUsers.length > 0) {
			// Check if the option to remove users is enabled
			if (this.data.canRemoveUsers) {
				// Check if they can remove users anytime
				if (this.data.canRemoveUsersAnytime) {
					// Set variable to true to show the button later
					showRemoveUsersButton = true;
				} else {
					// Check the progress status of the selected users
					// To do that, first set the main variable to true
					// We're going to iterate each selected row and if
					// at least of the checks fail we're going to set
					// it back to false
					showRemoveUsersButton = true;

					// iterate each one
					this.selectedUsers.forEach( ( user ) => {
						// Check if the progress is "Not started"
						showRemoveUsersButton = showRemoveUsersButton && user.progressIsNotStarted;
					} );
				}
			}
		}

		// Now show or hide the button
		if (showRemoveUsersButton) {
			// Show the button
			this.$elements.removeUsersButton.show();
		} else {
			// Hide the button
			this.$elements.removeUsersButton.hide();
		}
	}

	evaluateRemoveLeadersButtonVisiblity(){
		// Create the variable we're going to use to finally
		// decide if we have to show or not the button
		let showRemoveLeadersButton = false;

		// Check if there are selected rows
		if (this.selectedLeaders.length > 0) {
			showRemoveLeadersButton = true;
		}

		// Now show or hide the button
		if (showRemoveLeadersButton) {
			// Show the button
			this.$elements.removeLeadersButton.show();
		} else {
			// Hide the button
			this.$elements.removeLeadersButton.hide();
		}

		// Add amount of users being removed to modal
		$( '.amount-group-leaders' ).text( this.selectedLeaders.length );

		let groupLeaderIds = [];
		$.each( this.selectedLeaders, ( index, user ) => {
			groupLeaderIds.push( user.userId );
		} );

		// Add all ids to button
		$( '#removing-group-leaders' ).val( groupLeaderIds.join( "," ) );
	}

	evaluateSendEmailsButtonVisiblity(){
		// For this one, just check if there are selected users
		if (this.selectedUsers.length > 0) {
			// Show the button
			this.$elements.sendEmailsButton.show();
		} else {
			// Hide the button
			this.$elements.sendEmailsButton.hide();
		}
	}

	updateDataOnModal(){
		// Listen when the modal is being opened
		this.$elements.container.on( 'modal-open', ( event, modalId, modal ) => {

			// Create an array with the list of users
			const selectedUsers = this.selectedUsers.map( ( user ) => {
				return user.userId;
			} );

			// Update number of users selected users
			this.$elements.numberOfUsers.text( selectedUsers.length );


			// Check if the modal id the the ID of the "Send emails" modal
			if (modalId == '#group-management-enrolled-users-table-send-password-modal') {
				// Add the array as a string to a hidden field inside the Send password reset modal
				this.$elements.sendEmailsField.val( JSON.stringify( selectedUsers ) );
			} else if (modalId == '#group-management-remove-user') {

				// Create a comma separated list with the IDs
				const userIds = selectedUsers.join( ',' );

				// Add the list of IDs on a hidden field
				this.$elements.removeUsersField.val( userIds );
			}
		} );
	}

	hasEnrolledUsersTable(){
		return $( '#group-management-enrolled-users-datatable' ).length == 1;
	}
}

export default GroupManagement;
